import { ServiceMaker, methods, services } from "@/services";

export const createCommissionRule = payload =>
  ServiceMaker(
    `/subscription-payments/commissionrule`,
    methods.POST,
    services.master,
    payload
  );

export const fetchCommissionRuleById = id =>
  ServiceMaker(
    `/subscription-payments/commissionrule/${id}`,
    methods.GET,
    services.master
  );

export const fetchCommissionRuleAll = () =>
  ServiceMaker(
    `/subscription-payments/commissionrule`,
    methods.GET,
    services.master
  );

export const updateCommissionRule = payload =>
  ServiceMaker(
    `/subscription-payments/commissionrule/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );
export const deleteCommissionRule = payload =>
  ServiceMaker(
    `/subscription-payments/commissionrule/${payload}`,
    methods.DELETE,
    services.master,
    {}
  );
export const createCommissionRuleAssign = payload =>
  ServiceMaker(
    `subscription-payments/commissionruleassign`,
    methods.POST,
    services.master,
    payload
  );
export const cancelCommissionRuleAssign = payload =>
  ServiceMaker(
    `/subscription-payments/commissionruleassign/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );
export const fetchCommissionRuleAssignList = id =>
  ServiceMaker(
    `/subscription-payments/commissionruleassign/list/${id}`,
    methods.GET,
    services.master,
  );

  export const getCommissionTransactionList = payload =>
  ServiceMaker(
    `subscription-payments/commissionrule/transactions/list`,
    methods.POST,
    services.master,
    payload
  );

  export const getCommissionChart = payload =>
  ServiceMaker(
    `subscription-payments/commissionrule/transactions/graph?months=12`,
    methods.POST,
    services.master,
    payload
  );
  